__turbopack_context__.v({
  "free-samples-banner": "free-samples-banner-component-module-scss-module__tPdS8W__free-samples-banner",
});
